import { ArticleType } from '../shared/Carousel/Carousel.types';
import CarouselWrapper from '../shared/Carousel/CarouselWrapper/CarouselWrapper';
import UiHeading from '../shared/Heading';
import UiBox from '../shared/Box';
import { StArticleCarouselInner, StArticleCarouselRoot } from './ArticleCarousel.style';

function ArticleCarousel(props: ArticleType): JSX.Element {
  if (!props?.fields) return <></>;

  return (
    <StArticleCarouselRoot id="article-carousel" className="ui-article-carousel">
      <StArticleCarouselInner>
        <UiBox styles={{ marginBottom: '1rem' }}>
          <UiHeading size="h2" align="center">
            {props?.fields?.sectionTitle}
          </UiHeading>
        </UiBox>
        <CarouselWrapper {...props} callerComponent="Articles" />
      </StArticleCarouselInner>
    </StArticleCarouselRoot>
  );
}

export default ArticleCarousel;
